import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a8deaf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "formCap"
}
const _hoisted_2 = {
  key: 1,
  class: "block options-select"
}
const _hoisted_3 = { class: "price-red" }
const _hoisted_4 = { class: "price-unit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pull_down_select = _resolveComponent("pull-down-select")!
  const _component_input_field = _resolveComponent("input-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.productList.length !== 0)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, "オプション品"))
      : _createCommentVNode("", true),
    (_ctx.productList.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("dl", {
            class: _normalizeClass(["options-list", { multiple: _ctx.productList.length > 1 }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (option, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.pro_name_id,
                class: "option"
              }, [
                _createElementVNode("dt", null, [
                  _createTextVNode(_toDisplayString(option.pro_name) + "： ", 1),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getOptionPrice(option)) + "円/日(税込) ", 1)
                ]),
                _createElementVNode("dd", null, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_input_field, {
                      label: "レンタル台数",
                      "input-name": 'optional-product-select-' + (index + 1),
                      class: "unit"
                    }, {
                      default: _withCtx(({ inputName }) => [
                        _createVNode(_component_pull_down_select, {
                          options: _ctx.prepareUnitOptions(),
                          name: inputName,
                          modelValue: _ctx.optionSelectedStatus[option.pro_name_id],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.optionSelectedStatus[option.pro_name_id]) = $event)
                        }, null, 8, ["options", "name", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["input-name"])
                  ])
                ])
              ]))
            }), 128))
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}